import { useUpserveRebranding } from "./useUpserveRebranding";

export const useBranding = (lightspeedBranding?: string) => {
  const isUpserveRebrandingEnabled = useUpserveRebranding();
  return isUpserveRebrandingEnabled
    ? "Upserve"
    : (lightspeedBranding ?? "Lightspeed Restaurant (U-Series)");
};
